<template>
  <Bar
    :id="chartId"
    :data="chartData"
    :options="options"
  />
</template>

<script>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'StackedBarChart',
  components: { Bar },
  props: {
    chartId: String,
    chartData: Object
  },
  computed: {
    options () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom'
          }
        },
        scales: {
          x: { stacked: true },
          y: { stacked: true }
        }
      }
    }
  }

}
</script>
